import ApiService from '../../services/apiService';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import get from 'lodash/get';
export default {
  name: 'ViewAccountMgmtAccountMgmtSuperAdminTerminal',
  mixins: [tenantPickerMixin],
  data: function () {
    return {
      callPath: 'abac.debugCacheClear',
      params: '{}',
      isLoading: false,
      errorResponse: null,
      validResponse: null,
      availableActions: [],
      modules: [],
      loadingModules: false,
      moduleTogglePrompt: false,
      moduleToToggle: null,
      moduleDoDelete: false,
      rules: [],
      ruleDeletePrompt: false,
      ruleDeleteObj: null
    };
  },
  computed: {
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    jsonRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired'), v => {
        try {
          JSON.parse(v);
        } catch (error) {
          return 'INVALID JSON';
        }
        return true;
      }];
    },
    buttons() {
      return [{
        title: 'EXEC ACTION',
        icon: 'fal fa-wand-magic',
        action: 'execAction',
        valid: !this.isLoading
      }];
    }
  },
  mounted() {
    this.fetchModules();
    this.fetchActions();
  },
  methods: {
    fetchActions() {
      return ApiService.execConsoleAction('$node.actions', {
        skipInternal: true,
        onlyAvailable: true
      }).then(data => {
        this.availableActions = data.map(action => {
          action.params = get(action, 'action.params') || {};
          return action;
        }).sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    fetchModules() {
      Promise.all([ApiService.execConsoleAction('abac.fetchModules', {}), ApiService.fetchRules()]).then(data => {
        this.modules = data[0];
        this.loadingModules = false;
        this.rules = data[1].filter(r => get(r, 'subject[0]', '').toLowerCase() !== 'all' || get(r, 'actions[0]', '').toLowerCase() !== 'manage').sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    toggleModule(key, doDelete) {
      return ApiService.execConsoleAction('abac.removeModule', {
        moduleKey: key,
        doDelete
      }).then(() => {
        this.fetchModules();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    deleteRule(ruleId) {
      return ApiService.execConsoleAction('abac.deleteRule', {
        id: ruleId
      }).then(() => {
        this.fetchModules();
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    },
    execAction() {
      this.errorResponse = null;
      this.validResponse = null;
      this.isLoading = true;
      try {
        const params = JSON.parse(this.params);
        return ApiService.execConsoleAction(this.callPath.trim(), params).then(res => {
          if (typeof res === 'string') {
            this.validResponse = res;
          } else {
            this.validResponse = JSON.stringify(res, null, 1);
          }
        }).catch(error => {
          this.errorResponse = `${error}`;
          if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
            this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
          } else {
            this.$snack(this.$i18n_t('Common.oops1'), 'error');
          }
        }).finally(() => {
          this.isLoading = false;
        });
      } catch (error) {
        this.errorResponse = `${error}`;
        this.isLoading = false;
      }
    }
  }
};